import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { BaseComponent } from '../base/base.component';
import { activeTrainingPageEnum } from '../training-management/training-management/training-management.component';
@Component({
  selector: 'app-menu-blocks',
  templateUrl: './menu-blocks.component.html',
  styleUrls: ['./menu-blocks.component.scss']
})
export class MenuBlocksComponent extends BaseComponent implements OnInit {

  activeTrainingPageEnum = activeTrainingPageEnum;

  @Output() clicked: EventEmitter<object> = new EventEmitter();

  @ViewChild('blocks') blocks;

  @Input() arrMenuBlockData: {
    icon: String,
    title: String,
    description?: String

  }[];

  @Input() appLinks: string[] = [];

  constructor(elementRef: ElementRef) {
    super(elementRef);
  }

  ngOnInit() {
  }

  onClick(id: number) {
    this.clicked.emit({index: id, event: 'selected'});
  }

  setFocus() {
    this.blocks.nativeElement.focus();
  }

}



// WEBPACK FOOTER //
// D:/Work/Biddle/biddle-training-module/biddle-training-admin/src/app/core/components/menu-blocks/menu-blocks.component.ts